<template>
  <v-dialog :value="value" max-width="640" @input="$emit('input', $event)">
    <v-card class="card-shadow border-radius-xl">
      <div class="card-header-padding card-border-bottom">
        <h5 class="font-weight-bold text-h5 text-typo mb-0">
          {{ $t("Imprimir_documentos_admissao") }}
        </h5>
        <p class="text-sm text-body mb-0">
          {{ (preContratacao && preContratacao.nomeSocial) || "" }}
        </p>
      </div>
      <v-card-text class="pt-4">
        <div v-if="carregando" class="text-center py-6" role="status">
          <v-progress-circular indeterminate color="#5e72e4" />
        </div>
        <p v-else-if="!modelos.length" class="text-sm text-body mb-0">
          {{ $t("Nenhum_modelo_documentacao_admissao") }}
        </p>
        <template v-else>
          <p class="text-sm text-body mb-2">
            {{ $t("Selecione_modelos_documentacao_admissao") }}
          </p>
          <v-checkbox
            v-for="modelo in modelos"
            :key="modelo.id"
            v-model="selecionados"
            :value="modelo.id"
            :label="modelo.descricao"
            hide-details
            dense
            class="mt-1"
          />
        </template>
      </v-card-text>
      <v-card-actions class="px-6 pb-4">
        <v-spacer />
        <v-btn
          class="
            ma-1
            font-weight-bold
            text-capitalize
            btn-ls btn-secondary
            bg-gradient-light
            px-6
          "
          height="39"
          @click="fechar"
        >
          {{ $t("Cancelar") }}
        </v-btn>
        <v-btn
          class="
            ma-1
            font-weight-bold
            text-none
            btn-primary
            bg-gradient-primary
            px-6
          "
          height="39"
          :loading="imprimindo"
          :disabled="!selecionados.length"
          @click="imprimir"
        >
          <v-icon left>mdi-printer-outline</v-icon>
          {{ $t("Imprimir") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DataService from "@/services/pessoal/FuncionarioPreContratracaoDataService";

// Modelos de documentação acessória da admissão para pré-contratações ainda não aprovadas.
export default {
  name: "DialogoDocumentosPreContratacao",
  props: {
    value: { type: Boolean, default: false },
    preContratacao: { type: Object, default: null },
    // Dados da tela de aprovação ainda não gravados (contrato, movimentação e dados pessoais).
    dados: { type: Object, default: null },
  },
  data() {
    return {
      modelos: [],
      modelosCarregados: false,
      selecionados: [],
      carregando: false,
      imprimindo: false,
    };
  },
  watch: {
    value: {
      handler(aberto) {
        if (aberto) {
          this.carregarModelos();
        }
      },
      immediate: true,
    },
  },
  methods: {
    async carregarModelos() {
      if (this.modelosCarregados) {
        this.selecionados = this.modelos.map((modelo) => modelo.id);
        return;
      }
      this.carregando = true;
      try {
        const response = await DataService.getModelosDocumentacaoAcessoria();
        this.modelos = response.data || [];
        this.modelosCarregados = true;
        this.selecionados = this.modelos.map((modelo) => modelo.id);
      } catch (error) {
        this.$swal.fire(
          this.$t("Erro"),
          await this.mensagemErro(error, "Nao_foi_possivel_carregar"),
          "error"
        );
        this.fechar();
      } finally {
        this.carregando = false;
      }
    },
    async imprimir() {
      if (
        !this.preContratacao ||
        !this.selecionados.length ||
        this.imprimindo
      ) {
        return;
      }
      this.imprimindo = true;
      try {
        const response = await DataService.printDocumentacaoAcessoria(
          this.preContratacao.id,
          { modelos: this.selecionados, dados: this.dados }
        );
        this.download(response.data, "documentos-admissao.pdf");
        this.fechar();
      } catch (error) {
        this.$swal.fire(
          this.$t("Erro"),
          await this.mensagemErro(error, "Falha_ao_imprimir_documentos"),
          "error"
        );
      } finally {
        this.imprimindo = false;
      }
    },
    // Com responseType blob, a mensagem da API chega como Blob.
    async mensagemErro(error, padrao) {
      const data = error?.response?.data;
      try {
        const json =
          data && typeof data.text === "function"
            ? JSON.parse(await data.text())
            : data;
        if (json?.message) {
          return json.message;
        }
      } catch (err) {
        // resposta sem JSON
      }
      return this.$t(padrao);
    },
    download(content, fileName) {
      const blob = new Blob([content], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    fechar() {
      this.$emit("input", false);
    },
  },
};
</script>
